// removed by extract-text-webpack-plugin
module.exports = {"footer":"_15_0tPMfJwmdsP8fbjeW2p","akzoFooter":"_1-CQjrzVI8K3r3-xSHwiJf","a-akzonobelLogo":"_16XeoK61wcd4GxdnIUfzt3","flourishFooter":"_34LNBJ6PQfPkLPEmFC9zK9"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Footer/flourishStyle.scss
// module id = 876
// module chunks = 0